import { Component, OnInit, EventEmitter,Output, Input, OnChanges } from '@angular/core';



@Component({
  selector: 'btn-toggle',
  templateUrl: './btn-toggle.component.html',
 
  
})
export class BtnToggleComponent implements  OnInit ,OnChanges{
  ngOnInit(): void {
  }

  ngOnChanges(){
  }
 
  @Output() changed = new EventEmitter<boolean>();

  @Input() text:string;
  @Input() id:string;
  @Input() isChecked:boolean = true;
  @Input() isDisabled:boolean = false;
}